import { InitOptions } from 'i18next'
import conjunctionFormat from './conjunctionFormat'

export const initOptions: InitOptions = {
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en'],
  keySeparator: false,
  interpolation: {
    escapeValue: false,
    format: (value: Iterable<string>, format?: string, language?: string): string => {
      if (format === 'and') return conjunctionFormat(value, language as Intl.Locale | undefined)
      return value as string
    },
  },
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json', // Path where your translation files are located
  },
  parseMissingKeyHandler: (key) => {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(`[i18n] Missing key: "${key}"`)
    }
    return key
  },
}
